import { gql } from '@apollo/client/index.js'

export const EXPERT_REVIEWS_QUERY = gql`
query ExpertReviewsQuery($locale : String! $preview : Boolean!) {
  expertReviews :json(id:"2143Uo0jib8jsfRyWv2DDQ", locale : $locale, preview : $preview) {
    content
  }
}`
